const checkListItemSourceType = {
    SYSTEM_RULE : 'SystemRule',

    USER_RULE : 'UserRule',

    USER : 'User'

};

angular.module('gw-um-j2js')
    .constant('checkListItemSourceType', checkListItemSourceType);